import React, { useState } from 'react';

import RequestService from "../../services/request.service";

import AuthService from '../../features/auth/auth.service'

import { Button, Modal, Form } from 'react-bootstrap';

import { toast } from 'react-toastify'


import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from 'date-fns/locale/es';

import moment from 'moment'


import { SERVER_ } from  '../../config';



const ModalLayoutSUE = ( params : any ) => {

  const user = AuthService.getCurrentUser()

  const { show, handleClose } = params


  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(null);
  const onChange = (dates:any) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const descargarReporte = () => {

    window.open(`${SERVER_}layout_sue/${moment(startDate).format('YYYY-MM-DD')}/${moment(endDate).format('YYYY-MM-DD')}`)

  }


  return (
    <>
      <Modal show={show} size="sm" onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Layout SUE</Modal.Title>
        </Modal.Header>
        <Modal.Body>



                   <Form.Group className="mb-3" controlId="uuid_cliente">
                    <Form.Label>Rango de Fecha de Reporte</Form.Label>

                      <DatePicker
                        selected={startDate}
                        onChange={onChange}
                        startDate={startDate}
                        endDate={endDate}
                        maxDate={new Date()}
                        selectsRange
                        inline
                      />

                  </Form.Group>



        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="success" onClick={descargarReporte} type="button">Descargar <i className="fa fa-file-excel-o"/></Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}


export default ModalLayoutSUE;